import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { useTranslations } from 'next-intl';

import StyledConfirmationLayer from './confirmationLayer.style';
import Copy from '../../atoms/copy/copy';
import Headline from '../../atoms/headline/headline';

import CloseIcon from '../../icons/close.svg';

const ConfirmationLayer = forwardRef((props, ref) => {
  const { confirmationText, confirmationHeadline, onAccept, acceptButton } = props;

  const t = useTranslations();

  const [layerIsOpen, setLayerIsOpen] = useState(false);
  const confirmationLayerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openLayer: () => setLayerIsOpen(true),
    closeLayer: () => setLayerIsOpen(false)
  }));

  useEffect(() => {
    ReactModal.setAppElement('#__next');
  }, []);

  const closeLayer = () => {
    setLayerIsOpen(false);
  };

  return (
    <StyledConfirmationLayer
      innerRef={confirmationLayerRef}
      isOpen={layerIsOpen}
      onRequestClose={closeLayer}
      contentLabel="Confirmation Layer"
    >
      <button type="button" onClick={closeLayer} className="confirmationLayer__close">
        <CloseIcon aria-label={t('close')} width="15" height="15" />
      </button>

      <div className="confirmationLayer__text">
        <Headline className="confirmationLayer__headline" secondary>
          {confirmationHeadline || t('download.confirmationHeadline')}
        </Headline>

        <Copy>{confirmationText || t('download.confirmationText')}</Copy>
      </div>

      <div className="confirmationLayer__accept">
        {onAccept && !acceptButton ? (
          <button type="button" onClick={onAccept}>
            {t('download.accept')}
          </button>
        ) : (
          acceptButton
        )}
      </div>
    </StyledConfirmationLayer>
  );
});

// display name for React DevTools since we used forwardRef
ConfirmationLayer.displayName = 'ConfirmationLayer';

ConfirmationLayer.propTypes = {
  confirmationHeadline: PropTypes.string,
  confirmationText: PropTypes.string,
  onAccept: PropTypes.func,
  acceptButton: PropTypes.node
};

export default ConfirmationLayer;
